<template>
  <div>
    <!-- Global POS Features -->
    <v-card outlined class="mb-4">
      <v-card-title class="text-subtitle-1 font-weight-medium">
        {{ $t('pos_setting.label.global_features') }}
      </v-card-title>
      <v-card-text>
        <v-row>
          <v-col cols="12">
            <v-switch
              v-model="predefinedTicketsEnabled"
              :label="$t('pos_setting.label.predefined_tickets_enabled')"
              @change="savePredefinedTicketsSetting"
              inset
              hide-details
              class="mt-0"
            />
            <p class="text-caption grey--text mt-1 mb-0">
              {{ $t('pos_setting.label.predefined_tickets_hint') }}
            </p>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>

    <!-- Per-store Settings -->
    <v-expansion-panels accordion class="mt-4">
      <v-expansion-panel
        v-for="(dep, idx) in departments"
        :key="dep.id"
      >
        <v-expansion-panel-header>
          {{ dep.name }}
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <v-row class="pt-2">
            <v-col cols="12" sm="6">
              <v-switch
                v-model="dep.settings.print_order_on_save"
                :label="$t('pos_setting.label.department.print_order_on_save')"
                dense
                inset
                hide-details
              />
            </v-col>
            <v-col cols="12" sm="6">
              <v-switch
                v-model="dep.settings.print_order_on_update"
                :label="$t('pos_setting.label.department.print_order_on_update')"
                dense
                inset
                hide-details
              />
            </v-col>
            <v-col cols="12" sm="6">
              <v-switch
                v-model="dep.settings.print_invoice_on_save"
                :label="$t('pos_setting.label.department.print_invoice_on_save')"
                dense
                inset
                hide-details
              />
            </v-col>
          </v-row>
          <v-row class="mt-2">
            <v-col cols="12" class="d-flex justify-end">
              <v-btn
                color="primary"
                small
                :loading="loading"
                @click="updateSettings(dep.id)"
              >
                {{ $t('button.save') || 'Save' }}
              </v-btn>
            </v-col>
          </v-row>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
  </div>
</template>

<script>
export default {
  name: 'POSDefaults',
  data () {
    return {
      departments: [],
      loading: false,
      predefinedTicketsEnabled: false
    }
  },
  methods: {
    getDepartments () {
      this.$departmentService.getDepartments()
        .then(data => {
          this.departments = data
        })
    },
    updateSettings (id) {
      this.loading = true
      this.$departmentService.updateDepartmentSettings(id, this.departments.find(d => d.id === id).settings)
        .then(data => {
          this.notify(this.$t('pos_setting.message.updated'))
        })
        .catch(this.globalErrHandle)
        .then(() => {
          this.loading = false
        })
    },
    savePredefinedTicketsSetting (value) {
      this.$ticketNameService.updateSettings({ enabled: value })
        .then(() => this.notify(this.$t('pos_setting.message.updated')))
        .catch(this.globalErrHandle)
    }
  },
  mounted () {
    this.$emit('parent-title', this.$t('pos_setting.name') || 'POS Settings')
    this.$emit('parent-description', '')
    this.getDepartments()
    this.$ticketNameService.getSettings()
      .then(data => { this.predefinedTicketsEnabled = data.enabled })
      .catch(() => {})
  }
}
</script>
